/*
 * Authors: mariushirjanu
 * Created: 19/10/2021
 */
import { Component, Input, OnInit } from '@angular/core';
import { FileUploadDefault } from './file-upload-default';
import { GaMessageService } from '../message/ga-message.service';
import { TranslationService } from '../translation/translation.service';
import { FileUploadService, IFileUpload, IFileUploadFailResponse } from './file-upload.service';
import { AuthService } from '../services/auth/auth.service';

@Component({
  selector: 'image-upload',
  template: `
    <img *ngIf="imageAttached" [src]="imageUrl" alt="" style="max-width: 100%; max-height: 100px;"/>
    <span *ngIf="!imageAttached" translate>{{ textMissingImage }}</span>

    <div class="upload-picture col-space-top" *ngIf="hasWritePermission">
      <file-button [url]="imageUrl" [autoUpload]="true" [formData]="uploadFormData" [submitting]="busy" [uploading]="uploading" (onFileAdd)="onFileAdd($event)" (onUploadStarted)="onUploadStarted()" (onUploadDone)="onUploadDone($event)" (onUploadFailed)="onUploadFailed($event)" [dropZone]="dropZone">
        <i *ngIf="!uploading" class="fa fa-folder-open-o"></i>&nbsp;
        <span *ngIf="imageAttached" translate>APP.USER_PROFILE.USER_INFO.CHANGE_PICTURE</span>
        <span *ngIf="!imageAttached" translate>APP.USER_PROFILE.USER_INFO.ADD_PICTURE</span>
      </file-button>
      <button *ngIf="imageAttached" class="btn btn-default margin-left-sm" (click)="deleteImage(imageUrl)" [busyButton]="deleteBusy">
        <i class="fa fa-trash-o"></i><span translate> GA.BUTTONS.DELETE</span>
      </button>
    </div>
  `
})
export class ImageUploadComponent extends FileUploadDefault implements OnInit {
  @Input() public url:string; // display & upload url
  @Input() public hasImage:boolean;
  @Input() public hasWritePermission:boolean;
  @Input() public textMissingImage:string;
  @Input() public textDeleteImage:string;
  @Input() public dropZone:string;

  public imageUrl:string;
  public imageAttached:boolean;
  public deleteBusy:boolean;

  constructor(
    protected authService:AuthService,
    protected gaMessageService:GaMessageService,
    protected translationService:TranslationService,
    protected fileUploadService:FileUploadService
  ) {
    super(gaMessageService, translationService);

    // define some custom status messages
    this.statusMessages = {
      uploadingMessage: 'WEBSHOP.UPLOADING_LOGO',
      failedMessage: 'WEBSHOP.ERROR_UPLOADING_LOGO'
    };
  }

  public ngOnInit() {
    this.imageAttached = this.hasImage;
    this.imageUrl = this.getImageUrl();
  }

  public uploadSuccessFn = ():void => {
    this.imageAttached = true;
    this.imageUrl = this.getImageUrl(true);
  };

  public uploadFailedFn = ():void => {
    this.imageAttached = false;
  };

  public getImageUrl(refresh?:boolean):string {
    let url:string = this.url;
    if (refresh) {
      url += `?r=${Date.now()}`;
    }
    return this.authService.authenticatedUrl(url);
  }

  // ------

  public onUploadDone(result:IFileUpload):void {
    super.onUploadDone(result, this.uploadSuccessFn);
  }

  public onUploadFailed(response:IFileUploadFailResponse):void {
    super.onUploadFailed(response, this.uploadFailedFn);
  }

  public deleteImage(imageUrl:string):void {
    this.deleteBusy = true;
    this.fileUploadService.showDeleteFileConfirmationDialog(undefined, imageUrl, this.textDeleteImage)
      .then(() => {
        this.imageAttached = false;
        this.imageUrl = undefined;
      })
      .finally(() => {
        this.deleteBusy = false;
      });
  }
}